import 'datatables.net-bs4';
import 'datatables.net-responsive-bs4';
import 'datatables.net-rowgroup-bs4'
export default (function () {

}());



// WEBPACK FOOTER //
// ./resources/js/admin/datatable/index.js